import styled from 'styled-components';

export default styled.div`
	justify-self: end;
	align-self: center;
	display: flex;
`;
